import { css } from '@emotion/react';
import { Box, BoxProps } from '@spark-web/box';
import { Text } from '@spark-web/text';

import { MarketplaceVendor } from '~/types/marketplace';

type VendorImageProps = Pick<MarketplaceVendor, 'logoUrl' | 'tradingName'> & {
  size?: 'default' | 'small';
  css?: BoxProps['css'];
};

export const VendorImage = ({ logoUrl, tradingName, size = 'default', css: customCss }: VendorImageProps) => {
  const widthMap = {
    default: '154px',
    small: '64px',
  };

  const aspectRatioMap = {
    default: 2,
    small: 1,
  };

  const imageStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '16px',
    borderRadius: '4px',
    aspectRatio: aspectRatioMap[size],
    border: '1px solid #D3D2D2',
    maxWidth: widthMap[size],
    height: '100%',
    marginBottom: '8px',
  };

  const getVendorInitials = (name: string) => {
    const initials = name
      .split(' ')
      .map((item) => item[0])
      .join('');

    if (initials.length <= 2) {
      return initials;
    } else {
      return initials.substring(0, 2);
    }
  };

  const VendorDefaultImage = () => (
    <Box alignItems="center" background="secondary" css={css({ ...imageStyle, width: '100%' })} role="img">
      <Text align="center" size="large">
        {getVendorInitials(tradingName)}
      </Text>
    </Box>
  );

  if (!logoUrl) {
    return <VendorDefaultImage />;
  }

  return (
    <Box css={css(imageStyle, customCss)}>
      <img
        src={logoUrl}
        alt={`${tradingName} logo`}
        style={{
          objectFit: 'contain',
          height: '100%',
          maxWidth: '100%',
        }}
      />
    </Box>
  );
};
